var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.224121,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#3F46AB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3343_4562",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.22412,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3343_4562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 24.2241C8.98333 24.2241 7.6875 23.6991 6.6125 22.6491C5.5375 21.5991 5 20.3158 5 18.7991C5 17.4991 5.39167 16.3408 6.175 15.3241C6.95833 14.3075 7.98333 13.6575 9.25 13.3741C9.66667 11.8408 10.5 10.5991 11.75 9.64912C13 8.69912 14.4167 8.22412 16 8.22412C17.95 8.22412 19.6042 8.90329 20.9625 10.2616C22.3208 11.62 23 13.2741 23 15.2241C24.15 15.3575 25.1042 15.8533 25.8625 16.7116C26.6208 17.57 27 18.5741 27 19.7241C27 20.9741 26.5625 22.0366 25.6875 22.9116C24.8125 23.7866 23.75 24.2241 22.5 24.2241H10.5ZM10.5 22.2241H22.5C23.2 22.2241 23.7917 21.9825 24.275 21.4991C24.7583 21.0158 25 20.4241 25 19.7241C25 19.0241 24.7583 18.4325 24.275 17.9491C23.7917 17.4658 23.2 17.2241 22.5 17.2241H21V15.2241C21 13.8408 20.5125 12.6616 19.5375 11.6866C18.5625 10.7116 17.3833 10.2241 16 10.2241C14.6167 10.2241 13.4375 10.7116 12.4625 11.6866C11.4875 12.6616 11 13.8408 11 15.2241H10.5C9.53333 15.2241 8.70833 15.5658 8.025 16.2491C7.34167 16.9325 7 17.7575 7 18.7241C7 19.6908 7.34167 20.5158 8.025 21.1991C8.70833 21.8825 9.53333 22.2241 10.5 22.2241Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDashboardIcon);
export default __webpack_public_path__ + "static/media/Cloud_Dashboard_icon.6607e084458b58f1f5108911b8fc71a2.svg";
export { ForwardRef as ReactComponent };